import React, { Component } from 'react';

import i18n from 'i18n-react';

import ContentHeader from 'components/ContentHeader';
import FavoriteLink from 'components/FavoriteLink';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

import { storageKeys } from 'settings';

export default class FavoriteView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      favorites: [],
    };
  }

  UNSAFE_componentWillMount() {
    this.setFavorites();
  }

  setFavorites() {
    return DataHandler.matchAppId().then((appId) =>
      StorageHandler.load(storageKeys.user).then((user) =>
        APIHandler.getFavorite(appId, user.email, { message: 'Called from FavoriteView.js' }).then((favorites) => {
          StorageHandler.save(storageKeys.favorites, favorites);
          const favoriteArray = [];
          const favoriteContent = [];
          favorites.data.forEach((el) => {
            favoriteContent.push(el);
          });
          DataHandler.getLanguage().then((lang) => {
            const locale = `${lang.langFile.toLowerCase()}-${lang.langFile
              .replace('PT', 'BR')
              .replace('ES', '41')
              .replace('Ko', 'KR')
              .toUpperCase()}`;
            if (favorites.data.length !== 0) {
              APIHandler.getFavoriteContent(favoriteContent, locale).then((res) => {
                res.pages.forEach((info, index) => {
                  const key = index;
                  favoriteArray.push(
                    <FavoriteLink
                      info={info}
                      favorites={favorites}
                      contentInfo={favoriteContent[key]}
                      key={`fav_${key}`}
                    />,
                  );
                });
                this.setState({ favorites: favoriteArray });
              });
            }
          });
        }),
      ),
    );
  }

  render() {
    const { favorites } = this.state;
    return (
      <div className="contentContainer">
        <ContentHeader
          header={i18n.translate('nav.favorites')}
          subtitle={i18n.translate('pageDescriptions.favorites')}
        />
        <div className="favorite__Container">
          {favorites.length === 0 && <p className="subtitle">{i18n.translate('general.noFavorites')}</p>}
          <div className="favorite__Grid">{favorites}</div>
        </div>
      </div>
    );
  }
}
